export enum MessageSenderEnum {
  DEALER = 1,
  DISTRIBUTOR = 2,
  CLIENT = 3,
}
